import axios from '@/utils/axios';

const apiUrl = {
  generate: '/sys/apikey/generate',
  info: '/sys/apikey/info',
  revoke: '/sys/apikey/revoke',
};

export function generateApiKey(params) {
  return axios.post(apiUrl.generate, params || {});
}

export function getApiKeyInfo() {
  return axios.get(apiUrl.info);
}

export function revokeApiKey() {
  return axios.post(apiUrl.revoke);
}